import React, { useCallback, useRef, useState } from "react";
import "../../../_shared/ProjectChat/Review.scss";
import "./_opc-split-panels.scss";

// Chat on the left, document on the right, with a draggable divider in the
// SME style (CD33): a pill handle, always visible, teal on hover / drag.
// `id` is "project-checkin" or "project-review" so the real styles apply.
// The divider's width (`.panel-resizer`, 8px): each card gives up half, so
// the two cards plus the gap fill the row exactly.
const GAP = 8;

const OpcSplitPanels = ({ id, left, right, initial = 45 }) => {
  const [leftWidth, setLeftWidth] = useState(initial);
  const [resizing, setResizing] = useState(false);
  const ref = useRef(null);

  const onMouseDown = useCallback((e) => {
    e.preventDefault();
    setResizing(true);
    document.body.style.cursor = "col-resize";
    document.body.style.userSelect = "none";
    const move = (ev) => {
      const box = ref.current?.getBoundingClientRect();
      if (!box) return;
      const pct = ((ev.clientX - box.left) / box.width) * 100;
      setLeftWidth(Math.min(70, Math.max(30, pct)));
    };
    const up = () => {
      setResizing(false);
      document.body.style.cursor = "";
      document.body.style.userSelect = "";
      document.removeEventListener("mousemove", move);
      document.removeEventListener("mouseup", up);
    };
    document.addEventListener("mousemove", move);
    document.addEventListener("mouseup", up);
  }, []);

  return (
    <div id={id} className={`mt-2 opc-split${resizing ? " is-resizing" : ""}`}>
      <div className="d-flex h-100" ref={ref}>
        <div
          className="left-panel opc-split__left pt-3 h-100"
          style={{ width: `calc(${leftWidth}% - ${GAP / 2}px)` }}
        >
          {left}
        </div>
        <div
          className="panel-resizer"
          onMouseDown={onMouseDown}
          role="separator"
          aria-orientation="vertical"
        >
          <div className="panel-resizer-handle" />
        </div>
        <div
          className="right-panel opc-split__right"
          style={{ width: `calc(${100 - leftWidth}% - ${GAP / 2}px)` }}
        >
          {right}
        </div>
      </div>
    </div>
  );
};

export default OpcSplitPanels;
